module.exports = __webpack_public_path__ + "static/media/fr.a7d33e19.png";